<template>
  <section>
    <Title :title-name="title.WaitRebook.titleName" :title-link="title.WaitRebook.titleLink" />
    <div class="WaitRebook">
      <div class="container" style="margin-top: 14pt">
        <p>Dear {{ pax.title }} {{ pax.first_name }} {{ pax.last_name }} ,</p>
        <div>
          <p>
            Your flight will be rebooked to the first available option by our rebooking team. We will keep you informed on the
            progress on this personal webpage we have created for you.
          </p>
          <p>
            Once we have the information on your onwards flight we will inform you further on the options we can offer you on this
            page.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title/index'

export default {
  name: 'WaitRebook',
  components: { Title }
}
</script>
